import {
  AlignItems,
  Box,
  Button,
  ButtonLayout,
  ButtonVariant,
  Color,
  ColorPreset,
  Glyph,
  Icon,
  useTheme,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";
import { motion } from "framer-motion";

import { ButtonFeedbackEnum } from "../../consts";

interface FeedbackButtonProps {
  buttonFeedback: ButtonFeedbackEnum;
  disabled?: boolean;
}

export const FeedbackButton: React.FC<FeedbackButtonProps> = ({
  buttonFeedback = ButtonFeedbackEnum.Default,
  disabled = false,
}) => {
  const { theme } = useTheme();

  const isSuccessful = buttonFeedback === ButtonFeedbackEnum.IsSuccessful;
  const isLoading = buttonFeedback === ButtonFeedbackEnum.IsLoading;

  return (
    <Button
      type="submit"
      variant={ButtonVariant.PrimaryOnLight}
      layout={[ButtonLayout.Full, null, ButtonLayout.Inline]}
      disabled={isLoading || disabled}
      {...(isSuccessful && {
        css: { backgroundColor: theme.color(Color.Success_300) },
      })}
    >
      <motion.div
        key={buttonFeedback}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ ease: "easeInOut" }}
      >
        <Box layout="flex" alignItems={AlignItems.Center}>
          {isLoading ? (
            <Icon
              color={ColorPreset.IconOnLight_01}
              name={Glyph.Spinner}
              size="24px"
            />
          ) : null}

          {isSuccessful ? (
            <Icon
              color={ColorPreset.IconOnDark_01}
              name={Glyph.Tick}
              size="24px"
            />
          ) : null}

          {!isLoading && !isSuccessful ? (
            <Trans id="Continue">Continue</Trans>
          ) : null}
        </Box>
      </motion.div>
    </Button>
  );
};
